import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveContainer, Line, LineChart } from 'recharts';

import StyledTinyLineChart from './styled';
import { getLineGradient, getLineShadow, GRADIENT_ID, SHADOW_ID } from './utils';

const SIZE = {
  width: '200px',
  height: '150px'
};

export const TinyLineChart = ({
  data,
  dataKey,
  lineType = 'monotone',
  size = SIZE,
  withShadow,
  gradientColor,
  color = 'var(--cornflowerBlue)'
}) => (
  <StyledTinyLineChart $size={size}>
    <ResponsiveContainer width="100%" height="100%">
      <LineChart data={data}>
        <defs>
          {withShadow ? getLineShadow() : null}
          {gradientColor ? getLineGradient(gradientColor) : null}
        </defs>
        <Line
          dataKey={dataKey}
          connectNulls
          stroke={gradientColor ? `url(#${GRADIENT_ID})` : color}
          filter={withShadow ? `url(#${SHADOW_ID})` : ''}
          type={lineType}
          dot={false}
          strokeWidth={2}
        />
      </LineChart>
    </ResponsiveContainer>
  </StyledTinyLineChart>
);

TinyLineChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  dataKey: PropTypes.string.isRequired,
  size: PropTypes.shape({
    width: PropTypes.string.isRequired,
    height: PropTypes.string.isRequired
  }),
  withShadow: PropTypes.bool,
  gradientColor: PropTypes.string,
  color: PropTypes.string,
  lineType: PropTypes.oneOf([
    'basis',
    'basisClosed',
    'basisOpen',
    'linear',
    'linearClosed',
    'natural',
    'monotoneX',
    'monotoneY',
    'monotone',
    'step',
    'stepBefore',
    'stepAfter'
  ])
};
